import type { ComponentType } from 'react'
import AttackReportCheckpoint from '../../app/(preview)/preview/attack-report-checkpoint'
import ChatUnreadCheckpoint from '../../app/(preview)/preview/chat-unread-checkpoint'
import NativeDetails from '../../app/(preview)/preview/native-regressions'
import DiceLuckPreview from '../../app/(preview)/preview/dice-luck'
import CardTutorial from '../../app/(preview)/preview/card-turn-in'
import CardNames from '../../app/(preview)/preview/card-names'
import TeamEliminated from '../../app/(preview)/preview/team-eliminated'
import LogoEasterEggFrames from '../../app/(preview)/preview/logo-easter-egg-frames'
import Screen0 from '../../app/(app)/bots/[profile]'
import Screen1 from '../../app/(app)/bots/index'
import Screen3 from '../../app/(app)/games/[id]/dm/[userId]'
import TeamChatScreen from '../../app/(app)/games/[id]/dm/team'
import Screen5 from '../../app/(app)/games/[id]/index'
import Screen6 from '../../app/(app)/games/[id]/map-details'
import Screen7 from '../../app/(app)/games/[id]/players'
import Screen9 from '../../app/(app)/games/[id]/setup'
import Screen10 from '../../app/(app)/games/index'
import Screen11 from '../../app/(app)/games/new'
import Screen12 from '../../app/(app)/hof/index'
import Screen13 from '../../app/(app)/hof/win-rate'
import Screen14 from '../../app/(app)/index'
import Screen15 from '../../app/(app)/join/[code]'
import Screen16 from '../../app/(app)/leaderboard'
import Screen17 from '../../app/(app)/maps/[id]'
import Screen18 from '../../app/(app)/maps/index'
import Screen19 from '../../app/(app)/settings/about'
import Screen20 from '../../app/(app)/settings/account/email'
import Screen21 from '../../app/(app)/settings/account/name'
import Screen22 from '../../app/(app)/settings/account/real-name'
import Screen23 from '../../app/(app)/settings/account'
import Screen24 from '../../app/(app)/settings/blocked-users'
import Screen25 from '../../app/(app)/settings/contact'
import Screen26 from '../../app/(app)/settings/help'
import Screen27 from '../../app/(app)/settings/inbox/[id]'
import Screen28 from '../../app/(app)/settings/inbox/index'
import Screen29 from '../../app/(app)/settings/index'
import Screen30 from '../../app/(app)/settings/invite'
import Screen31 from '../../app/(app)/settings/notifications'
import Screen32 from '../../app/(app)/settings/report-user'
import Screen33 from '../../app/(app)/settings/rules'
import Screen34 from '../../app/(app)/settings/stats'
import Screen35 from '../../app/(app)/tutorial'
import Screen36 from '../../app/(app)/u/[username]'
import Screen37 from '../../app/(auth)/check-email'
import Screen38 from '../../app/(auth)/confirm-email/[token]'
import Screen39 from '../../app/(auth)/confirm-email-change/[token]'
import Screen40 from '../../app/(auth)/forgot-password'
import Screen41 from '../../app/(auth)/login'
import Screen42 from '../../app/(auth)/register'
import Screen43 from '../../app/(auth)/reset-password'
import Screen44 from '../../app/invite/[code]'

export const VISUAL_SCREENS: Record<string, ComponentType> = {
  'chat-unread-controls': ChatUnreadCheckpoint,
  'attack-report-controls': AttackReportCheckpoint,
  'native-details': NativeDetails,
  'dice-luck-modal': DiceLuckPreview,
  'card-tutorial': CardTutorial,
  'card-names': CardNames,
  'team-eliminated': TeamEliminated,
  'logo-easter-egg': LogoEasterEggFrames,
  'bots-profile': Screen0,
  'bots-index': Screen1,
  'games-id-dm-user-d': Screen3,
  'games-id-dm-team': TeamChatScreen,
  'games-id-index': Screen5,
  'game-placement-ready': Screen5,
  'game-waiting-ready': Screen5,
  'game-settings': Screen5,
  'game-filtered': Screen5,
  'games-id-map-details': Screen6,
  'games-id-players': Screen7,
  'games-id-rules': Screen5,
  'lobby-invited': Screen5,
  'lobby-special-rules': Screen5,
  'game-menu-invited': Screen5,
  'games-id-setup': Screen9,
  'games-index': Screen10,
  'games-new': Screen11,
  'hof-index': Screen12,
  'hof-win-rate': Screen13,
  'index': Screen14,
  'join-code': Screen15,
  'leaderboard': Screen16,
  'maps-id': Screen17,
  'maps-index': Screen18,
  'settings-about': Screen19,
  'settings-account-email': Screen20,
  'settings-account-name': Screen21,
  'settings-account-real-name': Screen22,
  'settings-account': Screen23,
  'settings-blocked-users': Screen24,
  'settings-contact': Screen25,
  'settings-help': Screen26,
  'settings-inbox-id': Screen27,
  'settings-inbox-index': Screen28,
  'settings-index': Screen29,
  'settings-invite': Screen30,
  'settings-notifications': Screen31,
  'settings-report-user': Screen32,
  'settings-rules': Screen33,
  'settings-stats': Screen34,
  'tutorial': Screen35,
  'u-username': Screen36,
  'auth-check-email': Screen37,
  'auth-confirm-email-token': Screen38,
  'auth-confirm-email-change-token': Screen39,
  'auth-forgot-password': Screen40,
  'auth-login': Screen41,
  'auth-register': Screen42,
  'auth-reset-password': Screen43,
  'invite-code': Screen44,
}
